import React from "react";

import { APP_DOMAIN, APP_DOMAIN_MAP } from "data/domainMap";

export const useAppMeta = (title = null) => {
  const hostname = window.location.hostname;

  const appMeta = React.useMemo(() => {
    const _matchedAppDomain = Object.keys(APP_DOMAIN_MAP).find((key) =>
      hostname.includes(key)
    );

    if (_matchedAppDomain) return APP_DOMAIN_MAP[_matchedAppDomain];

    return APP_DOMAIN_MAP[APP_DOMAIN.TMS];
  }, [hostname]);

  React.useEffect(() => {
    const _titlePrefix = appMeta.title;

    if (title?.length) {
      const _docTitle = `${_titlePrefix} | ${title}`;
      document.title = _docTitle;
    }

    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", appMeta.description);
    document
      .querySelector('meta[property="og:image"]')
      .setAttribute("content", appMeta["og:image"]);
    document
      .querySelector('meta[property="og:summary_large_image"]')
      .setAttribute("content", appMeta["og:summary_large_image"]);
  }, [appMeta, title]);

  return { hostname, appMeta };
};
